import { Edit, ShowButton, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import SaveErasmusCoordinatorsForm from "./Partials/SaveForm";

const EditErasmusCoordinators = () => {
  return (
    <Edit
      mutationMode="pessimistic"
      title="Редактирай координатор"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canPreviewErasmusCoordinators}>
              <ShowButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleForm>
        <SaveErasmusCoordinatorsForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditErasmusCoordinators;
